import React, { FC } from 'react';

export enum DataTestId {
    CLICK_OUT = 'click-out',
    BUSINESS_LOGIN = 'business-login',
    USER_LOGIN = 'user-login',
    SEARCH = 'search',
    MUTE = 'mute',
    SHARE = 'share',
    PROFILE = 'profile',
    FEED = 'feed',
    BOOKMARK = 'bookmark',
    LIKE = 'like',
    DISLIKE = 'dislike',
    SUBSCRIBE = 'subscribe',
    DESCRIPTION_EXPANDED = 'description-expanded',
    SLIDER_LEFT = 'slider-left',
    SLIDER_RIGHT = 'slider-right',
}

interface DataTestIdWrapperProps {
    children: React.ReactNode;
    dataTestId: DataTestId;
}

export const DataTestIdWrapper: FC<DataTestIdWrapperProps> = ({ children, dataTestId }) => (
    // TODO: Сделать привязку к dev окрожению, когда появится беты
    <div data-test-id={dataTestId}>{children}</div>
);
